import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { color, SubheadlineStyle, font, fontWeight } from 'styles/global'
import { space } from 'styles/utils'

export const buttonStyles = css`
  ${SubheadlineStyle};
  align-items: center;
  background: ${color('interactive')};
  border: 0;
  border-radius: 32px;
  color: ${color('secondaryText')};
  display: flex;
  font-family: ${font('extended')};
  font-size: 0.823rem;
  font-weight: ${fontWeight('bold')};
  justify-content: center;
  letter-spacing: 0.06em;
  line-height: 1.2;
  min-height: 32px;
  padding: ${space(2)} ${space(4)};
  text-transform: uppercase;
  transition: 0.1s background-color;
  will-change: background-color;

  &:hover {
    background-color: ${color('interactiveHover')};
  }
  &[disabled] {
    opacity: 0.8;
    pointer-events: none;
  }
`
export const Button = styled.button<{
  secondary?: boolean
}>`
  ${buttonStyles};
  ${({ secondary }) =>
    secondary &&
    css`
      padding: ${space(2)} 0;
      background-color: unset;
      color: ${color('interactive')};
      fill:  ${color('interactive')};
      &:hover {
        background-color: unset;
        color: ${color('interactiveHover')};
        fill:  ${color('interactiveHover')};
    `}
`

export const buttonLinkStyles = css`
  ${SubheadlineStyle};
  align-items: center;
  background: ${color('interactive')};
  border: 0;
  border-radius: 32px;
  color: ${color('secondaryText')};
  display: flex;
  font-family: ${font('extended')};
  font-size: 0.823rem;
  font-weight: ${fontWeight('bold')};
  justify-content: center;
  letter-spacing: 0.06em;
  line-height: 1.2;
  min-height: 32px;
  padding: ${space(2)} ${space(4)};
  text-transform: uppercase;
  transition: 0.1s background-color;
  width: max-content;
  will-change: background-color;
  &:hover {
    background-color: ${color('interactiveHover')};
  }
`

export const ButtonLink = styled(Link)`
  ${buttonLinkStyles}
  &[disabled] {
    background-color: ${color('disabled')};
  }
  &.secondary {
    background-color: unset;
    color: ${color('interactive')};
    fill: ${color('interactive')};
    padding: 0;
    &:hover {
      background-color: unset;
      color: ${color('interactiveHover')};
      fill: ${color('interactiveHover')};
    }
  }
`
